// extracted by mini-css-extract-plugin
export default {"topProductsTabsBlock":"promotion-media-top-products_topProductsTabsBlock__4TZwq","hiddenMessage":"promotion-media-top-products_hiddenMessage__zxbK1"};